import { render, staticRenderFns } from "./World.vue?vue&type=template&id=0b6a0860&"
var script = {}
import style0 from "./World.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports